export const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
export const calcAspRatio = (width, height) => {
  const ratioValue = gcd(width, height);
  const imgRatio = `${width / ratioValue}:${height / ratioValue}`;
  return imgRatio;
};

export const isVideo = type => type && type.startsWith('video');
